module.exports = __webpack_public_path__ + "img/home.3226ad43.png";